/**
 * @desc 红人管理-导入KOL
 */
const URL = "/rantion-kol";
import http, { updateResponse } from "@/http";
export type Response = defs.kol.Response;
export function request(body: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/kol/celebrity/importExcel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
